export default __webpack_public_path__ + "d94537c62f65ae6e2624ff6e047db572.png";